import { BaseContainerModel } from "../base-container.model";
import { bl_fi_generic_doc_expenses_adjustment_RowInterface, bl_fi_generic_doc_expenses_adjustment_RowClass } from "../../dbschema";

export class GenericDocExpensesContainerAdjustmentModel extends BaseContainerModel {
  bl_fi_generic_doc_expenses_adjustment: bl_fi_generic_doc_expenses_adjustment_RowInterface = new bl_fi_generic_doc_expenses_adjustment_RowClass();
}
